"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = Tbody;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react2 = require("@chakra-ui/react");

var _jsxRuntime = require("react/jsx-runtime");

// deps
// components
function Tbody(props) {
  const {
    children
  } = props;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_react2.Tbody, {
    children: children
  });
}

Tbody.propTypes = {
  children: _propTypes.default.node
};